export const likeWorks = {
	state: {
    likeWorks: [
      
    ],
	},
	mutations: {
    setLikeWorks (state, likeWorks) {
      if (Array.isArray(likeWorks)) {
        state.likeWorks = likeWorks
      } else {
        throw new TypeError(`the likeWorks is not a Array [vuex]`)
      }
    },

    clearLikeWorks (state) {
      state.likeWorks = null
    },
	},
	actions: {
    
	},
	getters: {
    likeWorks: state => state.likeWorks,
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/like-works/index.js